import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from './utils/axios.util';
import {backendUrlV2} from '~/config';
import {QuizRequest, QuizResponse, RewriteQuestionOrOptionRequest, RewriteQuestionOrOptionResponse, Question, AddNewOptionRequest, GenerateImageRequest, GenerateImageResponse, QuestionType} from './types/quiz.types';
import {normalizeQuestionType} from './utils/question-type-adapter';

export const quizApi = createApi({
  reducerPath: 'quizApi',
  baseQuery: axiosBaseQuery({baseUrl: backendUrlV2}),

  // Tag types for caching
  tagTypes: [],

  endpoints: builder => ({
    generateQuizQuestions: builder.mutation<QuizResponse, QuizRequest>({
      query: body => ({
        url: '/ai/quiz/question-generation',
        method: 'POST',
        data: {
          ...body,
          question_type: normalizeQuestionType(body?.question_type),
          allow_multiple_correct: body?.question_type === QuestionType.MULTIPLE_RESPONSE,
        },
      }),
    }),

    rewriteQuestionOrOption: builder.mutation<RewriteQuestionOrOptionResponse, RewriteQuestionOrOptionRequest>({
      query: body => ({
        url: '/ai/quiz/question-modification',
        method: 'POST',
        data: {
          ...body,
          question_type: normalizeQuestionType(body?.question_type ?? QuestionType.MULTIPLE_CHOICE),
        },
      }),
    }),

    addNewOption: builder.mutation<Question, AddNewOptionRequest>({
      query: body => ({
        url: '/ai/quiz/option-addition',
        method: 'POST',
        data: {
          ...body,
          question: {
            ...body?.question,
            question_type: normalizeQuestionType(body?.question?.question_type),
          },
        },
      }),
    }),

    generateImage: builder.mutation<GenerateImageResponse, GenerateImageRequest>({
      query: body => ({
        url: '/ai/quiz/image-generation',
        method: 'POST',
        data: body,
      }),
    }),
  }),
});

export const {useGenerateQuizQuestionsMutation, useRewriteQuestionOrOptionMutation, useAddNewOptionMutation, useGenerateImageMutation} = quizApi;
